import {RE_API_URL} from "../../utils/constants";

export class MyUploadAdapter {
  constructor(props, firstEmptyId, imageCounter, incrementImageCounter, apiRequest) {
    // console.log(firstEmptyId);
    this.firstEmptyId = firstEmptyId;
    // CKEditor 5's FileLoader instance.
    this.loader = props;
    this.incrementImageCounter = incrementImageCounter;
    this.imageCounter = imageCounter;
    this.apiRequest = apiRequest;
    // URL where to send files.
  }

  // Starts the upload process.
  upload() {
    return this.loader.file
      .then(file => new Promise((resolve, reject) => {
        this._initRequest(resolve, reject, file);
      }));

  }


  // Example implementation using XMLHttpRequest.
  _initRequest(resolve, reject, file) {
    const baseUrl = `${RE_API_URL}/assistant/images`;
    let promise = this.getBase64(file);
    let temp_id = this.firstEmptyId
    let imageCounter = this.imageCounter;
    let incrementImageCounter = this.incrementImageCounter;
    let temp_name = file.name
    let api = this.apiRequest
    console.log('this.apiRequest',this.apiRequest)
    promise.then(function (result) {
      api.post(baseUrl, {
        'empty_id': temp_id,
        'image_data': result,
        'imagecounter': imageCounter,
        'file_name': temp_name
      }, {
        'Content-Type': 'application/text',
      }).then(function (response) {
        //handle success
        incrementImageCounter();
        resolve({
          default: response.file_path
        });
      })
        .catch(function (response) {
          //handle error
          console.log(response);
        });

    });

  }


  getBase64(file, onLoadCallback) {
    return new Promise(function (resolve, reject) {
      let reader = new FileReader();
      reader.onload = function () {
        resolve(reader.result);
      };
      reader.onerror = reject;
      reader.readAsDataURL(file);
    });
  }
}